import React from 'react';
import { branch, compose, renderComponent, withStateHandlers } from 'recompose';
import { Icon } from '../../../../components';
import { boxed } from '../../../../components/higher-order';
import PlanUpgradeDetail from './plan-upgrade-detail';

const PlanUpgrade = ({
  show,
  onShow
}) => ([
  <div key={0} className='text-center'>
    <h2 type="button" onClick={onShow}>
      Upgrade to business plan <Icon className="pull-right" icon='plus-large' iconSize={2}></Icon>
    </h2>
  </div>
])

export default compose(
  withStateHandlers(
    () => ({
      show: false
    }),
    {
      onShow: () => () => ({ show: true })
    }
  ),
  boxed,
  branch(
    ({ show }) => show,
    renderComponent(PlanUpgradeDetail)
  )
)(PlanUpgrade)


// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/components/plan-upgrade.js